// extracted by mini-css-extract-plugin
module.exports = {"container":"_7Sh1rChOjNH6R-ZSnn1Yq","visible":"_3xqsr55vemfq1j4T3fAc8R","cancelBtn":"_144FQUapue08SIihtTwi6H","icon":"_1KbbRrB9kqej-evMixgPbw","saveBtn":"VGo4mzl4xeOcyr2v1QF02"};